import {useEffect, useState} from 'react';
import {AnimatePresence, motion} from 'motion/react';
import {Alert} from '@mui/material';
import {useNavigate} from 'react-router-dom';
import {useAuth} from '../../shared/auth/AuthContext';
import {loginPortalClient} from './LoginService';
import {getBackendErrorMessage} from '../../shared/utils/httpError';

const segments = [
    {
        category: 'Agronegócio',
        title: 'Avicultura',
        description: 'Soluções completas para gestão de granjas, controle de lotes, monitoramento de produção e rastreabilidade de aves. Otimize sua operação com tecnologia de ponta.',
        image: 'https://images.unsplash.com/photo-1538451825199-8605af521e85?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w3Nzg4Nzd8MHwxfHNlYXJjaHwxfHxwb3VsdHJ5JTIwZmFybSUyMGNoaWNrZW5zJTIwbW9kZXJuJTIwYWdyaWN1bHR1cmV8ZW58MXx8fHwxNzc4Njg5OTcxfDA&ixlib=rb-4.1.0&q=80&w=1080',
        badge: null,
    },
    {
        category: 'Indústria',
        title: 'Produção Industrial',
        description: 'Sistemas integrados para fábricas de alimentos e rações. Controle de formulação, produção, qualidade, estoque e rastreabilidade completa da cadeia produtiva.',
        image: 'https://images.unsplash.com/photo-1774887810190-5de1cc9cb06e?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w3Nzg4Nzd8MHwxfHNlYXJjaHwxfHxpbmR1c3RyaWFsJTIwZm9vZCUyMHByb2R1Y3Rpb24lMjBmYWN0b3J5JTIwbWFudWZhY3R1cmluZ3xlbnwxfHx8fDE3Nzg2ODk5NzF8MA&ixlib=rb-4.1.0&q=80&w=1080',
        badge: null,
    },
    {
        category: 'Indústria',
        title: 'Frigoríficos e Abatedouros',
        description: 'Gestão especializada para plantas frigoríficas. Controle de abate, desossa, classificação, expedição e certificações sanitárias com total rastreabilidade.',
        image: 'https://images.unsplash.com/photo-1617448570699-14461c8f3def?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w3Nzg4Nzd8MHwxfHNlYXJjaHwxfHxtZWF0JTIwcHJvY2Vzc2luZyUyMHBsYW50JTIwaW5kdXN0cmlhbHxlbnwxfHx8fDE3Nzg2ODk5NzJ8MA&ixlib=rb-4.1.0&q=80&w=1080',
        badge: null,
    },
    {
        category: 'Comércio',
        title: 'Varejo e Distribuidoras',
        description: 'Plataforma completa para gestão comercial. PDV, estoque, compras, vendas, logística e relacionamento com clientes em um só lugar.',
        image: 'https://images.unsplash.com/photo-1759153820384-12c9ddf8bd8d?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w3Nzg4Nzd8MHwxfHNlYXJjaHwxfHxyZXRhaWwlMjBzdG9yZSUyMHN1cGVybWFya2V0JTIwbW9kZXJufGVufDF8fHx8MTc3ODY4OTk3Mnww&ixlib=rb-4.1.0&q=80&w=1080',
        badge: null,
    },
    {
        category: 'Em Desenvolvimento',
        title: 'Farmácias',
        description: 'Solução integrada para gestão farmacêutica. Controle de estoque, vendas, prescrições, anvisa e atendimento ao cliente.',
        image: 'https://images.unsplash.com/photo-1631367771698-606007aecd52?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w3Nzg4Nzd8MHwxfHNlYXJjaHwxfHxwaGFybWFjeSUyMG1vZGVybiUyMGludGVyaW9yfGVufDF8fHx8MTc3ODY4OTk3M3ww&ixlib=rb-4.1.0&q=80&w=1080',
        badge: 'Em breve',
    },
    {
        category: 'Em Desenvolvimento',
        title: 'PetShop',
        description: 'Sistema completo para pet shops. Gestão de produtos, serviços, agendamentos, banho e tosa, e relacionamento com tutores.',
        image: 'https://images.unsplash.com/photo-1555325084-b068599743c9?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w3Nzg4Nzd8MHwxfHNlYXJjaHwxfHxwZXQlMjBzaG9wJTIwc3RvcmUlMjBhbmltYWxzfGVufDF8fHx8MTc3ODY4OTk3M3ww&ixlib=rb-4.1.0&q=80&w=1080',
        badge: 'Em breve',
    },
    {
        category: 'Em Desenvolvimento',
        title: 'Clínicas e Saúde',
        description: 'Plataforma para clínicas médicas e odontológicas. Prontuário eletrônico, agendamentos, faturamento e gestão completa.',
        image: 'https://images.unsplash.com/photo-1777269749032-d8d458ae594d?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w3Nzg4Nzd8MHwxfHNlYXJjaHwxfHxtZWRpY2FsJTIwY2xpbmljJTIwaG9zcGl0YWwlMjBtb2Rlcm58ZW58MXx8fHwxNzc4Njg5OTczfDA&ixlib=rb-4.1.0&q=80&w=1080',
        badge: 'Em breve',
    },
];

export function LoginPage() {
    const navigate = useNavigate();
    const {login} = useAuth();
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [currentSegment, setCurrentSegment] = useState(0);
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        const interval = setInterval(() => {
            setCurrentSegment((prev) => (prev + 1) % segments.length);
        }, 10000);
        return () => clearInterval(interval);
    }, []);

    const handleSubmit = async (event) => {
        event.preventDefault();
        setError('');
        const credentials = {
            email: email.trim(),
            password,
        };
        if (!credentials.email || !credentials.password) {
            setError('Informe e-mail e senha para entrar.');
            return;
        }
        try {
            setLoading(true);
            const session = await loginPortalClient(credentials);
            login({
                ...session,
                email: session.email || credentials.email,
            });
            navigate('/', {replace: true});
        } catch (submitError) {
            setError(getBackendErrorMessage(submitError, 'Não foi possível autenticar no portal.'));
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="bf-login">
            <div className="bf-login__showcase">
                <AnimatePresence mode="wait">
                    <motion.div
                        key={currentSegment}
                        initial={{opacity: 0}}
                        animate={{opacity: 1}}
                        exit={{opacity: 0}}
                        transition={{duration: 1, ease: 'easeInOut'}}
                        style={{position: 'absolute', inset: 0, display: 'flex'}}
                    >
                        <div style={{width: '30%', position: 'relative'}}>
                            <img src={segments[currentSegment].image} alt={segments[currentSegment].title} style={{width: '100%', height: '100%', objectFit: 'cover'}} />
                        </div>
                        <div style={{flex: 1, position: 'relative', display: 'flex', alignItems: 'center', background: 'linear-gradient(to right, rgba(37, 99, 235, 0.03) 0%, rgba(6, 182, 212, 0.03) 30%, rgba(248, 250, 252, 0.95) 60%, rgba(248, 250, 252, 1) 100%)'}}>
                            <div style={{position: 'absolute', inset: 0, background: 'linear-gradient(to right, rgba(37, 99, 235, 0.03) 0%, rgba(6, 182, 212, 0.03) 30%, rgba(248, 250, 252, 0.95) 60%, rgba(248, 250, 252, 1) 100%)'}} />
                            <div style={{position: 'relative', zIndex: 1, padding: '48px 64px', maxWidth: 672}}>
                                <div style={{display: 'flex', alignItems: 'center', gap: 16, marginBottom: 24}}>
                                    {segments[currentSegment].badge ? <span className="bf-pill bf-pill--accent" style={{padding: '6px 12px', borderRadius: 999}}>{segments[currentSegment].badge}</span> : null}
                                </div>
                                <div style={{marginBottom: 12}}><span style={{fontSize: 12, fontWeight: 600, color: 'var(--bf-primary)', textTransform: 'uppercase', letterSpacing: 1.2}}>{segments[currentSegment].category}</span></div>
                                <h2 style={{fontSize: 48, lineHeight: 1.05, fontWeight: 700, margin: '0 0 24px', letterSpacing: '-0.03em'}}>{segments[currentSegment].title}</h2>
                                <p style={{fontSize: 18, color: 'var(--bf-muted-foreground)', lineHeight: 1.75, margin: 0}}>{segments[currentSegment].description}</p>
                                <div style={{marginTop: 48, paddingTop: 32, borderTop: '1px solid rgba(226,232,240,0.5)'}}>
                                    <img src="/logo_black.svg" alt="BusiFarm" style={{height: 32, width: 'auto'}} />
                                    <p style={{fontSize: 12, color: 'var(--bf-muted-foreground)', marginTop: 8}}>Tecnologia para o Agronegócio</p>
                                </div>
                            </div>
                        </div>
                    </motion.div>
                </AnimatePresence>
            </div>

            <div className="bf-login__form-wrap">
                <div className="bf-login__form-inner">
                    <div className="bf-login__center">
                        <img src="/logo_black.svg" alt="BusiFarm" className="bf-login__logo" />
                        <h2 style={{fontSize: 30, fontWeight: 700, margin: '0 0 8px', letterSpacing: '-0.02em'}}>Bem-vindo ao Portal BusiFarm</h2>
                        <p className="bf-muted" style={{margin: 0}}>Gerencie sua operação de forma centralizada.</p>
                    </div>

                    <div className="bf-card bf-login__card">
                        <form onSubmit={handleSubmit} className="bf-stack-3">
                            {error ? <Alert severity="error">{error}</Alert> : null}
                            <div className="bf-field">
                                <label className="bf-label" htmlFor="email">E-mail</label>
                                <input id="email" className="bf-input" type="email" autoComplete="email" placeholder="seu@email.com" value={email} onChange={(event) => setEmail(event.target.value)} required />
                            </div>
                            <div className="bf-field">
                                <label className="bf-label" htmlFor="password">Senha</label>
                                <input id="password" className="bf-input" type="password" autoComplete="current-password" placeholder="••••••••" value={password} onChange={(event) => setPassword(event.target.value)} required />
                            </div>
                            <button type="submit" className="bf-button bf-button--primary bf-button--lg bf-button--full" disabled={loading}>Entrar</button>
                            <div style={{textAlign: 'center'}}><button type="button" className="bf-button bf-button--ghost bf-button--sm" style={{color: 'var(--bf-primary)', padding: 0, minHeight: 'auto'}}>Esqueceu sua senha?</button></div>
                        </form>
                    </div>

                    <p className="bf-copyright">© 2026 BusiFarm. Todos os direitos reservados.</p>
                </div>
            </div>
        </div>
    );
}
